var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var ApiService = /** @class */ (function () {
    function ApiService(http, BASE_URL) {
        this.http = http;
        this.baseUrl = BASE_URL;
    }
    ApiService.prototype.get = function (endPoint) {
        return this.http.get(this.generateUrl(endPoint));
    };
    ApiService.prototype.post = function (endpoint, formData, addContentType) {
        if (addContentType === void 0) { addContentType = false; }
        if (!addContentType) {
            return this.http.post(this.generateUrl(endpoint), formData);
        }
        else {
            return this.http.post(this.generateUrl(endpoint), formData, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
        }
    };
    ApiService.prototype.delete = function (endpoint) {
        return this.http.delete(endpoint);
    };
    ApiService.prototype.generateUrl = function (endpoint) {
        return this.baseUrl + endpoint;
    };
    ApiService = __decorate([
        Injectable(),
        __param(1, Inject('BASE_URL')),
        __metadata("design:paramtypes", [HttpClient, String])
    ], ApiService);
    return ApiService;
}());
export { ApiService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhcGkuc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUVuRCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFJbEQ7SUFHSSxvQkFBMkIsSUFBZ0IsRUFBc0IsUUFBZ0I7UUFBdEQsU0FBSSxHQUFKLElBQUksQ0FBWTtRQUN2QyxJQUFJLENBQUMsT0FBTyxHQUFHLFFBQVEsQ0FBQztJQUM1QixDQUFDO0lBRU0sd0JBQUcsR0FBVixVQUFXLFFBQWdCO1FBQ3ZCLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO0lBQ3JELENBQUM7SUFFTSx5QkFBSSxHQUFYLFVBQVksUUFBZ0IsRUFBRSxRQUFnQixFQUFFLGNBQStCO1FBQS9CLCtCQUFBLEVBQUEsc0JBQStCO1FBQzNFLElBQUksQ0FBQyxjQUFjLEVBQUU7WUFDakIsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxDQUFDO1NBQy9EO2FBQU07WUFDSCxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsUUFBUSxDQUFDLEVBQUUsUUFBUSxFQUFFLEVBQUUsT0FBTyxFQUFFLEVBQUUsY0FBYyxFQUFFLGlDQUFpQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO1NBQ25JO0lBQ0wsQ0FBQztJQUVNLDJCQUFNLEdBQWIsVUFBYyxRQUFnQjtRQUMxQixPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ3RDLENBQUM7SUFFTyxnQ0FBVyxHQUFuQixVQUFvQixRQUFnQjtRQUNoQyxPQUFPLElBQUksQ0FBQyxPQUFPLEdBQUcsUUFBUSxDQUFDO0lBQ25DLENBQUM7SUF6QlEsVUFBVTtRQUR0QixVQUFVLEVBQUU7UUFJcUMsV0FBQSxNQUFNLENBQUMsVUFBVSxDQUFDLENBQUE7eUNBQS9CLFVBQVU7T0FIbEMsVUFBVSxDQTBCdEI7SUFBRCxpQkFBQztDQUFBLEFBMUJELElBMEJDO1NBMUJZLFVBQVUifQ==